import reactLogo from '../../assets/logos/react.svg'

interface ReactLogoProps {
  className?: string
}

/**
 * The React brand mark.
 *
 * Static on purpose. The Lottie icons on this site are illustrations we can treat as
 * we like; this is somebody else's trademark, and React's brand terms, like most,
 * do not permit animating or altering the mark.
 *
 * No dark mode filter either, unlike every Lottie icon here. The mark is React cyan,
 * which reads on both the white and the navy surface, and the filter the others use
 * (brightness-0 then invert) would flatten it to plain white and throw the brand
 * colour away. Inverting the hue instead would turn cyan orange, which is worse.
 */
const ReactLogo = ({ className = 'w-14 h-14' }: ReactLogoProps) => (
  <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
    <img src={reactLogo} alt="" aria-hidden="true" className="w-full h-full object-contain" />
  </div>
)

export default ReactLogo
